<template>
  <router-link :to="{ name: link }" @click="setActivatedMenu()">
    <button class="floating-button z-10" :title="title">
      <i :class="!icon ? 'fas fa-plus' : icon"></i>
    </button>
  </router-link>
</template>

<script>
import { storeApp } from '@/store'

export default {
  name: 'FloatCreate',
  props: {
    icon: String,
    link: { type: String, nullable: false },
    title: { String, default: 'Adicionar' },
    menuActive: { String, default: 'Inicio' }
  },
  methods: {
    setActivatedMenu () {
      storeApp.dispatch('setActivatedMenu', this.menuActive)
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-button {
  position: fixed;
  bottom: 20px;
  right:  20px;
  background-color: #b3a185;
  color: white;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  i {
    color: #fff;
    font-size: 30px;
  }

  &:hover {
    // background-image: linear-gradient(to right ,#1e7c84, #1accdd);
    // transform: translateY(-5px);
    transform: scale(1.1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }

  &:focus {
    // box-shadow: 0px 0px 0px 2px rgba(11, 112, 54, 0.5);
    outline: none;
    transform: scale(0.95);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.95);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}
</style>
